import { GET, POST } from '@/api/request';
import {
    GET_USER_INFO,
    LOCATION_TO_CITY,
    WX_SUBSCRIPTION_LOGIN,
    WX_SUBSCRIPTION_BIND,
    GET_INIT_CONFIG,
    GET_CITY_ID,
    GET_WX_CONFIG,
} from '@/api';
import {
    QZ_ABBREVIATION,
    QZ_ROUTER_PARAMS,
    QZ_CURRENT_SCENE,
    LOCATION_CURRENT,
    LOCATION_SET,
    GET_LOCATION_TIME,
    QZ_KF_CONFIG,
    QZ_KF_QSK_CONFIG,
    QZ_PLATFORM_ID,
} from 'constant';
import loginModel from '@/components/loginModel';
import confirm from '@/components/confirm';
import { PAGE_SET_CITY, PAGE_CUSTOMER_SERVICE } from 'page';
import store from '@/store';
import router from '@/router';
import { Indicator } from 'mint-ui';
// 同一时间只允许一个定位任务运行，并发调用共享同一个结果。
let locationPromise = null;
let locationPermissionDenied = false;
let locationPermissionWatcherStarted = false;
let locationPromptShown = false;
let debounceTime = {};
let throttleTime = {};
let throttlePrevious = 0;
let platformInfoCache = null;

function positionSuccess({ data = null } = {}) {
    console.log('定位成功', data);
    let lat = data.position.lat;
    let lon = data.position.lng;
    return util.post(LOCATION_TO_CITY, {
        lat,
        lon,
    }).then(res => {
        if (res.success) {
            const location = {
                lat,
                lon,
                city: {
                    id: res.data.id,
                    name: res.data.name,
                },
            };
            store.commit('setCurrentLocation', location);
            locationPermissionDenied = false;
            if (locationPromptShown) {
                confirm.close();
                locationPromptShown = false;
            }
            // 定位恢复后，同城的手动选城应让位于 GPS 的真实经纬度。
            const selected = store.state.location.selectLocation;
            if (selected.city.id && selected.city.id == location.city.id) {
                store.commit('removeSelectLocation');
            }
            return { success: true, data: location };
        }
        return positionError({ message: (res && res.message) || '定位城市解析失败' });
    });
}

function positionError({ error = {}, message = '' } = {}) {
    console.error('定位失败', error);
    if (error && (error.code == 1 || error.code == error.PERMISSION_DENIED)) {
        locationPermissionDenied = true;
    }
    switch (error.code) {
        case error.PERMISSION_DENIED:
            console.error('用户拒绝请求地理定位');
            break;
        case error.POSITION_UNAVAILABLE:
            console.error('位置信息是不可用');
            break;
        case error.TIMEOUT:
            console.error('请求获取用户位置超时');
            break;
        case error.UNKNOWN_ERROR:
            console.error('定位系统失效');
            break;
        default:
            console.error('未知问题');
    }
    const pendingRoute = router.history && router.history.pending;
    const targetPath = pendingRoute ? pendingRoute.path : router.currentRoute.path;
    if (
        targetPath != PAGE_SET_CITY &&
        !store.state.location.selectLocation.city.id &&
        !store.state.location.currentLocation.city.id
    ) {
        showLocationPrompt();
    }
    return {
        success: false,
        message: message || '无法获取当前位置',
        error,
    };
}

function showLocationPrompt() {
    if (locationPromptShown) {
        return;
    }
    locationPromptShown = true;
    confirm.open({
        title: '定位提示',
        message: '未获取到定位授权或定位信息，请手动选择所在城市。',
        confirmText: '选择城市',
        hideCancelBtn: true,
        isShieldClose: true,
        success: () => {
            locationPromptShown = false;
            router.replace({
                path: PAGE_SET_CITY,
                query: {
                    type: 1,
                    source: window.location.href,
                },
            });
        },
    });
}

function setupLocationPermissionWatcher() {
    if (locationPermissionWatcherStarted) {
        return;
    }
    locationPermissionWatcherStarted = true;

    const retryLocation = () => {
        const pending = locationPromise;
        if (pending) {
            pending.then(() => util.getLocation());
        } else {
            util.getLocation();
        }
    };

    if (navigator.permissions && navigator.permissions.query) {
        navigator.permissions
            .query({ name: 'geolocation' })
            .then(permissionStatus => {
                permissionStatus.onchange = () => {
                    if (permissionStatus.state == 'granted') {
                        retryLocation();
                    }
                };
            })
            .catch(() => {});
    }

    // Safari 通常不支持权限变化监听，从系统设置返回页面时主动重试。
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState == 'visible' && locationPermissionDenied) {
            retryLocation();
        }
    });
}

const util = {
    /**
     * 生成guid
     */
    guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    },
    /**
     * 获取当前渠道信息
     */
    getPlatformInfo(platformId = '') {
        platformId = platformId || localStorage.getItem(QZ_PLATFORM_ID);
        if (platformInfoCache && platformInfoCache.platformId === platformId) {
            return platformInfoCache.promise;
        }
        platformInfoCache = {
            platformId,
            promise: GET(`${GET_INIT_CONFIG}/${platformId}`).then(res => {
                if (res.success) {
                    store.commit('setConfigError', null);
                    let stopSellMinuteOfSelfText = '';
                    if (res.data.stopSellMinuteOfSelf >= 60) {
                        stopSellMinuteOfSelfText += `${parseInt(res.data.stopSellMinuteOfSelf / 60)}小时`;
                    }
                    if (res.data.stopSellMinuteOfSelf % 60 != 0) {
                        stopSellMinuteOfSelfText += `${res.data.stopSellMinuteOfSelf % 60}分钟`;
                    }
                    res.data.stopSellMinuteOfSelfText = stopSellMinuteOfSelfText;
                    store.commit('setConfig', res.data);
                    store.commit('setWechatPayAllowDomains', res.data.wechatPayAllowDomains);
                    store.commit('setWechatPayRedirectDomain', res.data.wechatPayRedirectDomain);
                    if (store.getters.getExposeMethod.notWechatShare) {
                        document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
                            WeixinJSBridge.call('hideOptionMenu');
                        });
                    }
                } else {
                    store.commit('setConfigError', { platformId, message: '' });
                }
                return res;
            }),
        };
        return platformInfoCache.promise;
    },
    /**
     * 获取用户信息并同步数据
     */
    getUserInfo() {
        return POST(GET_USER_INFO).then(res => {
            if (res.success) {
                // 当无openId的时候去验证一下是否需要绑定
                if (!res.data.wxOpenId) {
                    util.wxMpLogin();
                }
                store.commit('setUserInfo', res.data);
                return res;
            }
            return {
                success: false,
            };
        });
    },
    /**
     * 获取当前定位
     */
    getLocation({ callback = null, presetLocation = null } = {}) {
        setupLocationPermissionWatcher();
        if (!locationPromise) {
            locationPromise = createLocationTask(presetLocation)
                .catch(error => positionError({ error }))
                .then(result => {
                    locationPromise = null;
                    return result;
                });
        }
        return locationPromise.then(result => {
            if (callback) {
                callback(result);
            }
            return result;
        });

        function createLocationTask(presetLocation) {
            const currentCache = readLocationCache(LOCATION_CURRENT);
            const selectCache = readLocationCache(LOCATION_SET);
            const cacheTasks = [];
            if (currentCache && !currentCache.city.id && currentCache.city.code) {
                cacheTasks.push(
                    util.post(GET_CITY_ID, { cityCode: currentCache.city.code }).then(res => {
                        if (res.success) currentCache.city.id = res.data.id;
                    })
                );
            }
            if (selectCache && !selectCache.city.id && selectCache.city.code) {
                cacheTasks.push(
                    util.post(GET_CITY_ID, { cityCode: selectCache.city.code }).then(res => {
                        if (res.success) {
                            selectCache.city.id = res.data.id;
                            selectCache.lon = res.data.longitude;
                            selectCache.lat = res.data.latitude;
                        }
                    })
                );
            }
            return Promise.all(cacheTasks).then(() => {
                if (!store.state.location.currentLocation.city.id && currentCache && currentCache.city.id) {
                    store.commit('setCurrentLocation', currentCache);
                }
                if (!store.state.location.selectLocation.city.id && selectCache && selectCache.city.id) {
                    store.commit('setSelectLocation', selectCache);
                }
                store.commit('setHasLocation', !!store.state.location.currentLocation.city.id);
                return prepareLocationEnvironment(presetLocation);
            });
        }

        function readLocationCache(key) {
            const value = localStorage.getItem(key);
            if (!value) return null;
            try {
                const data = JSON.parse(value);
                if (!data || typeof data != 'object' || !data.city || typeof data.city != 'object') {
                    throw new Error('invalid location cache');
                }
                return data;
            } catch (error) {
                console.error('定位缓存无效', key, error);
                localStorage.removeItem(key);
                return null;
            }
        }

        function prepareLocationEnvironment(presetLocation) {
            return new Promise(resolve => {
                let started = false;
                const startBrowserLocation = () => {
                    if (started) return;
                    started = true;
                    resolve(getBrowserLocation(presetLocation));
                };
                const fallbackTimer = setTimeout(startBrowserLocation, 3000);
                util.setCurrentScene()
                    .then(currentRes => {
                        if (!currentRes.success) return startBrowserLocation();
                        return store.dispatch('wechatPay').then(wechatPayRes => {
                            const writeDomains = wechatPayRes.allowDomains || [];
                            if (!store.getters.isWechatBrowser || writeDomains.indexOf(window.location.hostname) == -1) {
                                return startBrowserLocation();
                            }
                            return util.post(GET_WX_CONFIG, { url: store.state.common.wxConfigHref }).then(res => {
                                if (!res.success || !window.wx) return startBrowserLocation();
                                const config = Object.assign(res.data, {
                                    debug: false,
                                    jsApiList: [
                                        'chooseWXPay',
                                        'openLocation',
                                        'getLocation',
                                        'updateAppMessageShareData',
                                        'updateTimelineShareData',
                                        'onMenuShareTimeline',
                                        'onMenuShareAppMessage',
                                    ],
                                });
                                wx.config(config);
                                wx.ready(startBrowserLocation);
                                wx.error(startBrowserLocation);
                            });
                        });
                    })
                    .catch(startBrowserLocation)
                    .then(() => {
                        if (started) clearTimeout(fallbackTimer);
                    });
            });
        }

        function getBrowserLocation(presetLocation) {
            return new Promise(resolve => {
                let settled = false;
                let timer = null;
                const usePresetLocation = error => {
                    if (settled) return;
                    settled = true;
                    clearTimeout(timer);
                    if (presetLocation) {
                        resolve(positionSuccess({ data: { position: presetLocation } }));
                    } else {
                        resolve(positionError({ error }));
                    }
                };
                if (!navigator.geolocation) {
                    usePresetLocation();
                    return;
                }
                // WebView 未必遵守原生 timeout，额外保证初始化任务结束。
                timer = setTimeout(() => usePresetLocation({ code: 3, TIMEOUT: 3 }), GET_LOCATION_TIME + 1000);
                navigator.geolocation.getCurrentPosition(
                    position => {
                        if (settled) return;
                        settled = true;
                        clearTimeout(timer);
                        resolve(
                            positionSuccess({
                                data: {
                                    position: {
                                        lat: position.coords.latitude,
                                        lng: position.coords.longitude,
                                    },
                                },
                            })
                        );
                    },
                    usePresetLocation,
                    { enableHighAccuracy: false, maximumAge: 0, timeout: GET_LOCATION_TIME }
                );
            });
        }
    },
    /**
     * 获取客服链接
     */
    getCustomerService(orderNo = '', noLogin = false) {
        let defaultDomain = '';
        if (store.getters.isWechatBrowser) {
            defaultDomain = '//qz-kf.qianzhu8.com';
        } else {
            defaultDomain = '//kf.qianzhu8.com';
        }
        if (window.location.hostname.indexOf('qz-m') > -1) {
            defaultDomain = `//${window.location.hostname.replace('qz-m', 'qz-kf')}`;
        }
        return new Promise((resolve, reject) => {
            let kfConfig = QZ_KF_CONFIG;
            if (store.getters.getExposeMethod.showOrderComplaintBtn) {
                kfConfig = QZ_KF_QSK_CONFIG;
            }
            if (store.getters.getExposeMethod.kfDomain && store.getters.getExposeMethod.kfDomain.indexOf('tel:') > -1) {
                resolve({
                    success: true,
                    url: store.getters.getExposeMethod.kfDomain,
                });
            } else if (noLogin) {
                return resolve({
                    success: true,
                    url:
                        (store.getters.getExposeMethod.kfDomain || `${defaultDomain}`) +
                        `/api/mobileweb/home?source=${kfConfig.SOURCE}&channel_id=${kfConfig.CHANNEL_ID}&channel_key=${
                            kfConfig.CHANNEL_KEY
                        }&wechatapp_id=${kfConfig.WECHATAPP_ID}&key=${
                            kfConfig.KEY
                        }&orderNo=${orderNo}&nickName=短信用户-${new Date().getTime()}&note=${
                            store.state.common.platformId || ''
                        }`,
                });
            } else if (!store.state.user.userInfo.id) {
                this.getUserInfo().then(res => {
                    if (res.success) {
                        resolve({
                            success: true,
                            url:
                                (store.getters.getExposeMethod.kfDomain || `${defaultDomain}`) +
                                `/api/mobileweb/home?source=${kfConfig.SOURCE}&channel_id=${
                                    kfConfig.CHANNEL_ID
                                }&channel_key=${kfConfig.CHANNEL_KEY}&wechatapp_id=${kfConfig.WECHATAPP_ID}&key=${
                                    kfConfig.KEY
                                }&orderNo=${orderNo}&openid=${res.data.id}&nickName=${res.data.nickname || ''}&note=${
                                    store.state.common.platformId || ''
                                }&avatarUrl=${res.data.headImgUrl}`,
                        });
                    } else {
                        resolve({
                            success: false,
                            url:
                                (store.getters.getExposeMethod.kfDomain || `${defaultDomain}`) +
                                `/api/mobileweb/home?source=${kfConfig.SOURCE}&channel_id=${
                                    kfConfig.CHANNEL_ID
                                }&channel_key=${kfConfig.CHANNEL_KEY}&wechatapp_id=${kfConfig.WECHATAPP_ID}&key=${
                                    kfConfig.KEY
                                }&orderNo=${orderNo}&openid=${new Date().getTime()}&nickName=游客用户&note=${
                                    store.state.common.platformId || ''
                                }`,
                        });
                    }
                });
            } else {
                return resolve({
                    success: true,
                    url:
                        (store.getters.getExposeMethod.kfDomain || `${defaultDomain}`) +
                        `/api/mobileweb/home?source=${kfConfig.SOURCE}&channel_id=${kfConfig.CHANNEL_ID}&channel_key=${
                            kfConfig.CHANNEL_KEY
                        }&wechatapp_id=${kfConfig.WECHATAPP_ID}&key=${kfConfig.KEY}&orderNo=${orderNo}&openid=${
                            store.state.user.userInfo.id
                        }&nickName=${store.state.user.userInfo.nickname || ''}&note=${
                            store.state.common.platformId || ''
                        }&avatarUrl=${store.state.user.userInfo.headImgUrl}`,
                });
            }
        });
    },
    /**
     * 页面跳转
     * @param  {...any} args 入参
     */
    pageJump(...args) {
        let type = 0;
        let path = '/';
        let name = '';
        let query = null;
        let params = null;
        let config = {};
        if (typeof args[0] === 'string') {
            type = 0;
            path = args[0];
            query = args[1] || {};
            params = args[2] || {};
            config = args[3] || {};
        } else {
            type = 1;
            path = args[0].path;
            query = args[0].query || {};
            params = args[0].params || {};
            for (let k in args[0]) {
                if (k != 'path' && k != 'query' && k != 'params') {
                    config[k] = args[0][k];
                }
            }
            config = args[0].config || {};
        }
        if (PAGE_CUSTOMER_SERVICE == path && !store.state.user.token && !query.noLogin) {
            return loginModel.open();
        }
        if (params) {
            for (let i = 0; i < router.options.routes.length; i++) {
                const item = router.options.routes[i];
                if (item.path === path) {
                    name = item.name;
                    break;
                } else if (
                    item.children &&
                    item.children.length &&
                    this.analysisMultistageRouter(item.children, path).success
                ) {
                    name = this.analysisMultistageRouter(item.children, path).name;
                    break;
                }
            }
            localStorage.setItem(QZ_ROUTER_PARAMS, JSON.stringify(params));
        }
        if (query && query.titleName) {
            // this.setTitleName(query.titleName);
            store.commit('setTitleName', name);
        } else {
            store.commit('setTitleName', '');
        }
        if (query && !query.platformId) {
            query.platformId = store.state.common.platformId;
        }
        if (query && !query.subPlatformId && store.state.common.subPlatformId) {
            query.subPlatformId = store.state.common.subPlatformId;
        }
        if (query && !query.merchId && store.state.common.merchId) {
            query.merchId = store.state.common.merchId;
        }
        if (query && !query.promoterId && store.state.common.promoterId) {
            query.promoterId = store.state.common.promoterId;
        }
        if (router.currentRoute.query.hasOwnProperty('specialToken')) {
            query.specialToken = router.currentRoute.query.specialToken;
        }
        // if(query && query.specialToken){
        //     query.specialToken =
        // }
        query.ct = new Date().getTime();

        if (config.jumpType === 1) {
            router.replace({
                path,
                name,
                query,
                params,
            });
        } else {
            router.push({
                path,
                name,
                query,
                params,
            });
        }
    },
    /**
     * 清楚截流防抖时间
     */
    clearMyTime() {
        for (let k in debounceTime) {
            clearTimeout(debounceTime[k]);
            debounceTime[k] = null;
        }
        for (let k in throttleTime) {
            clearTimeout(throttleTime[k]);
            throttleTime[k] = null;
        }
    },
    /**
     * 解析子路由list
     * @param {Array} routeList 子路由的list
     * @param {String} path 跳转url名称
     */
    analysisMultistageRouter(routeList, path) {
        for (let i = 0; i < routeList.length; i++) {
            const item = routeList[i];
            if (item.path === path) {
                return {
                    success: true,
                    name: item.name,
                };
            } else if (
                item.children &&
                item.children.length &&
                this.analysisMultistageRouter(item.children, path).success
            ) {
                return this.analysisMultistageRouter(item.children, path).name;
            }
        }
        return {
            success: false,
        };
    },
    /**
     * 后退
     * @param {Int} n 回退页面层数
     */
    pageBack(n = 1) {
        store.commit('clearTitleName');
        router.go(-n);
    },
    /**
     * get 请求
     * @param  {...any} args 入参
     */
    get(...args) {
        return GET(...args);
    },
    /**
     * post 请求
     * @param  {...any} args 入参
     */
    post(...args) {
        return POST(...args);
    },
    /**
     * 获取上一个页面携带的参数
     * @param {String}} name 获取参数名称
     */
    getQueryString(name = '') {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURIComponent(r[2]);
        let lsParams = JSON.parse(localStorage.getItem(QZ_ROUTER_PARAMS));
        for (let k in lsParams) if (k == name) return lsParams[k];
        return null;
    },
    /**
     * 设置当前场景值
     */
    setCurrentScene() {
        return new Promise((resolve, reject) => {
            if (store.state.common.sceneType == 1) {
                return resolve({
                    success: true,
                    currentScene: store.state.common.currentScene,
                });
            } else if (navigator && navigator.userAgent) {
                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                    //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
                    let settled = false;
                    const finish = currentScene => {
                        if (settled) return;
                        settled = true;
                        clearTimeout(timer);
                        store.commit('setCurrentScene', currentScene);
                        resolve({ success: true, currentScene });
                    };
                    const fallback = () => finish(
                        window.__wxjs_environment === 'miniprogram' || ua.indexOf('miniprogram') > -1
                            ? QZ_CURRENT_SCENE.WX_MIN : QZ_CURRENT_SCENE.WX_BROWSER
                    );
                    // 部分微信 WebView 不回调 getEnv，不能让路由初始化一直等待。
                    const timer = setTimeout(fallback, 3000);
                    try {
                        if (!window.wx || !window.wx.miniProgram || !window.wx.miniProgram.getEnv) {
                            fallback();
                        } else {
                            window.wx.miniProgram.getEnv(res => finish(
                                res && res.miniprogram ? QZ_CURRENT_SCENE.WX_MIN : QZ_CURRENT_SCENE.WX_BROWSER
                            ));
                        }
                    } catch (error) {
                        console.error('wechat-env', error);
                        fallback();
                    }
                } else if (ua.match(/toutiaomicroapp/i) == 'toutiaomicroapp') {
                    // 防止头条 Jssdk 与 Rn 语法冲突
                    require('@/lib/toutiao/toutiao.tmajssdk.jssdk-1.0.1.js');
                    store.commit('setCurrentScene', QZ_CURRENT_SCENE.TT_MIN);
                    resolve({ success: true, currentScene: QZ_CURRENT_SCENE.TT_MIN });
                } else if (ua.match(/AlipayClient/i) == 'alipayclient') {
                    util.dynamicLoadJs('https://appx/web-view.min.js');
                    // 支付宝环境
                    if (ua.match(/MiniProgram/i) == 'miniprogram') {
                        // 支付宝小程序
                        store.commit('setCurrentScene', QZ_CURRENT_SCENE.ALIPAY_MIN);
                        resolve({ success: true, currentScene: QZ_CURRENT_SCENE.ALIPAY_MIN });
                    } else {
                        // 支付宝H5
                        store.commit('setCurrentScene', QZ_CURRENT_SCENE.ALIPAY_BROWSER);
                        resolve({ success: true, currentScene: QZ_CURRENT_SCENE.ALIPAY_BROWSER });
                    }
                } else if (ua.match(/swan/i) == 'swan') {
                    // 百度小程序环境
                    require('@/lib/baidu/swan-2.0.22.js');
                    store.commit('setCurrentScene', QZ_CURRENT_SCENE.BD_MIN);
                    resolve({ success: true, currentScene: QZ_CURRENT_SCENE.BD_MIN });
                } else {
                    store.commit('setCurrentScene', QZ_CURRENT_SCENE.APP);
                    resolve({ success: true, currentScene: QZ_CURRENT_SCENE.APP });
                }
            } else {
                store.commit('setCurrentScene', QZ_CURRENT_SCENE.APP);
                resolve({ success: true, currentScene: QZ_CURRENT_SCENE.APP });
            }
        });
    },
    /**
     * 设置标题名称
     * @param {String} name 标题名称
     */
    setTitleName(name = '') {
        store.commit('setTitleName', name);
        this.setDocumentTitle(name);
    },
    /**
     *
     * @param {String} name 标题名称
     */
    setDocumentTitle(name = '') {
        document.title = QZ_ABBREVIATION + (name ? ' - ' + name : '');
    },
    /**
     * 校验是否在android中
     */
    isAndroid() {
        var u = navigator.userAgent;
        return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    },
    /**
     * 微信公众号授权登录
     */
    wxMpLogin() {
        // 获取环境信息
        util.setCurrentScene().then(sceneRes => {
            if (sceneRes.success) {
                // 当在微信环境中触发
                if (store.getters.isWechatBrowser) {
                    // 有渠道 且 有token的时候去绑定授权
                    if (store.state.common.platformId && store.state.user.token) {
                        util.get(WX_SUBSCRIPTION_BIND).then(loginRes => {
                            if (loginRes.success) {
                                window.location.href = loginRes.data.bindUrl;
                            }
                        });
                    } else {
                        util.get(WX_SUBSCRIPTION_LOGIN).then(loginRes => {
                            if (loginRes.success) {
                                window.location.href = loginRes.data.authorizationUrl;
                            }
                        });
                    }
                }
            } else {
            }
        });
    },
    /**
     * 数组去重
     * @param {Array} list 目标数组
     * @param {String} name 字段名称
     */
    distinct(list = [], name = '') {
        if (typeof name == 'string') {
            if (name) {
                for (let i = 0; i < list.length; i++) {
                    for (let j = i + 1; j < list.length; j++) {
                        if (list[i][name] === list[j][name]) {
                            list.splice(j, 1);
                            j--;
                        }
                    }
                }
            } else {
                for (let i = 0; i < list.length; i++) {
                    for (let j = i + 1; j < list.length; j++) {
                        if (list[i] === list[j]) {
                            list.splice(j, 1);
                            j--;
                        }
                    }
                }
            }
            return list;
        } else {
            for (let i = 0; i < list.length; i++) {
                let iItem = list[i];
                for (let j = i + 1; j < list.length; j++) {
                    let jItem = list[j];
                    let isOk = false;
                    for (let k = 0; k < name.length; k++) {
                        const kItem = name[k];
                        if (iItem[kItem] === jItem[kItem] && iItem[kItem] && jItem[kItem]) {
                            isOk = true;
                            break;
                        }
                    }
                    if (isOk) {
                        list.splice(j, 1);
                        j--;
                    }
                }
            }
            return list;
        }
    },
    /**
     * 浏览器锁住滚动条
     */
    lockScreen() {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = -scrollTop + 'px';
    },
    /**
     * 解开浏览器滚动条
     */
    unlockScreen({ _top = null } = {}) {
        let top = _top == null ? -parseInt(document.body.style.top) : _top;
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.documentElement.scrollTop = top;
        document.body.scrollTop = top;
    },
    /**
     * 加载框
     * @param {String} text 文本
     */
    loading(text = '加载中...') {
        Indicator.open(text);
    },
    /**
     * 关闭加载框
     */
    unloading() {
        Indicator.close();
    },
    /**
     * 是否safari
     */
    isSafari() {
        var isSafari = false;
        var ua = navigator.userAgent.toLowerCase();
        //判断是不是在iPhone的Safair浏览器打开的本页面
        if (
            ua.indexOf('applewebkit') > -1 &&
            ua.indexOf('mobile') > -1 &&
            ua.indexOf('safari') > -1 &&
            ua.indexOf('linux') === -1 &&
            ua.indexOf('android') === -1 &&
            ua.indexOf('chrome') === -1 &&
            ua.indexOf('ios') === -1 &&
            ua.indexOf('browser') === -1
        ) {
            isSafari = true;
        }
        return isSafari;
    },
    /**
     * 关闭当前页面 使用页面回退的方式
     */
    closeWindow() {
        for (let i = 100; i > 0; i--) {
            window.history.go(-i);
        }
    },
    /**
     * 函数防抖
     * @param {Function}} func 函数
     * @param {Int}} wait 延迟执行毫秒数
     * @param {Bool} immediate 是否立即执行
     */
    debounce(func, wait = 1000, immediate = true) {
        return function () {
            let context = this;
            let args = arguments;
            if (debounceTime[func.name]) {
                clearTimeout(debounceTime[func.name]);
            }
            if (immediate) {
                var callNow = !debounceTime[func.name];
                debounceTime[func.name] = setTimeout(() => {
                    delete debounceTime[func.name];
                }, wait);
                if (callNow) func.apply(context, args);
            } else {
                debounceTime[func.name] = setTimeout(function () {
                    func.apply(context, args);
                }, wait);
            }
        };
    },
    /**
     * 函数节流
     * @param {Function} func 函数
     * @param {Int} wait 延迟执行毫秒数
     * @param {Int} type 版本 1. 时间戳 2.定时器
     */
    throttle(func, wait = 1000, type = 1) {
        return function () {
            let context = this;
            let args = arguments;
            if (type === 1) {
                let now = Date.now();
                if (now - throttlePrevious > wait) {
                    func.apply(context, args);
                    throttlePrevious = now;
                }
            } else if (type === 2) {
                if (!throttleTime[func.name]) {
                    throttleTime[func.name] = setTimeout(() => {
                        delete throttleTime[func.name];
                        func.apply(context, args);
                    }, wait);
                }
            }
        };
    },
    /**
     * 动态引入js
     * @param {String} url js链接
     * @param {Function} callback 回掉方法
     */
    dynamicLoadJs(url, callback) {
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        if (typeof callback == 'function') {
            script.onload = script.onreadystatechange = function () {
                if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
                    callback();
                    script.onload = script.onreadystatechange = null;
                }
            };
        }
        head.appendChild(script);
    },
};

export default util;
